/* Obtino: makes the carousel progress bar a real scrollbar (click + drag) in every browser. */
(function () {
  function initBar(progress) {
    if (!progress || progress.dataset.obScrollbar === 'true') return;
    var bar = progress.querySelector('[data-na-progress-bar]');
    var rail = progress.querySelector('.na-progress__track');
    var scope = progress.closest('.shopify-section') || progress.closest('section') || document;
    var track = scope.querySelector('[data-na-track]');
    if (!bar || !rail || !track) return;
    progress.dataset.obScrollbar = 'true';

    var dragging = false;
    var grabOffset = 0;

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function scrollToPointer(clientX) {
      var r = rail.getBoundingClientRect();
      var barW = bar.getBoundingClientRect().width;
      var usable = Math.max(1, r.width - barW);
      var ratio = (clientX - r.left - grabOffset) / usable;
      ratio = Math.min(1, Math.max(0, ratio));
      track.scrollLeft = ratio * maxScroll();
    }

    progress.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      var br = bar.getBoundingClientRect();
      grabOffset = e.clientX >= br.left && e.clientX <= br.right ? e.clientX - br.left : br.width / 2;
      dragging = true;
      try { progress.setPointerCapture(e.pointerId); } catch (err) {}
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      bar.style.transition = 'none';
      progress.classList.add('is-dragging');
      scrollToPointer(e.clientX);
      e.preventDefault();
    });

    progress.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      scrollToPointer(e.clientX);
      e.preventDefault();
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
      bar.style.transition = '';
      progress.classList.remove('is-dragging');
    }

    progress.addEventListener('pointerup', endDrag);
    progress.addEventListener('pointercancel', endDrag);
    progress.addEventListener('lostpointercapture', endDrag);

    /* Keyboard: left/right arrows move one card */
    progress.setAttribute('role', 'scrollbar');
    progress.setAttribute('tabindex', '0');
    progress.setAttribute('aria-orientation', 'horizontal');
    progress.removeAttribute('aria-hidden');
    progress.addEventListener('keydown', function (e) {
      var step = track.clientWidth / 2;
      if (e.key === 'ArrowRight') { track.scrollBy({ left: step, behavior: 'smooth' }); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { track.scrollBy({ left: -step, behavior: 'smooth' }); e.preventDefault(); }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.na-progress').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
